import { render, staticRenderFns } from "./EditProductDelete.vue?vue&type=template&id=303ffaca"
import script from "./EditProductDelete.vue?vue&type=script&lang=js"
export * from "./EditProductDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports